import {IExerciserSDK} from './IExerciserSDK';
import {IObserverApp} from './IObserverApp';
import {IContentManager} from './IContentManager';
import {IDataManager} from './IDataManager';
import {ISessionManager} from './ISessionManager'
import {IFirebase} from './IFirebase';
import {IAnalytics} from './IAnalytics';
import {ITts} from './ITts';

import {ObserverApp} from './ObserverApp';
import {ContentManager} from './ContentManager';
import {Firebase} from './Firebase';
import {DataManager} from './DataManager';
import {SessionManager} from './SessionManager'
import {Analytics} from './Analytics';
import {Tts} from './Tts';


export class ExerciserSDK implements IExerciserSDK {
  _observerApp:IObserverApp = null;
  _readyCallback = null;
  _contentManager:IContentManager = null;
  _config = null;
  _firebase:IFirebase = null;
  _dataManager:IDataManager = null;
  _sessionManager:ISessionManager = null;
  _tts:ITts = null;
  _analytics: IAnalytics = null;

  constructor(public config:any = {}, public ready:any) {
    this._config = config;
    this._readyCallback = ready;
    this._analytics = new Analytics(this._config.analyticsPrefix);
    this._contentManager = new ContentManager(this._config.contentManager);
    this._firebase = new Firebase(this._config.firebase);
    this._dataManager = new DataManager(this._config);
    this._sessionManager = new SessionManager(this._config);
    this._tts = new Tts(this._config.ttsApiEndpoint);
    this.initialize();
  }

  private initialize(): void {
    this._firebase.attach('initialized', this.onFirebaseInitialized.bind(this));
    new ObserverApp(this._config.appName, this.onObserverInitialized.bind(this));
  }

  private async onObserverInitialized(observerApp: any):Promise<void> {
    try {
      this._observerApp = observerApp;

      if (this._firebase) {
        await this._firebase.initialize();
      }
      if (this._sessionManager) {
        await this._sessionManager.initialize();
      }

    } catch(e) {
      console.error(e);
    }
  }

  private async onFirebaseInitialized():Promise<void> {
    if (this._dataManager) {
      await this._dataManager.initialize(this._firebase);
    }
    await this.attachLoginModuleListeners();

    if (this._readyCallback)
      this._readyCallback(this);
  }

  private async attachLoginModuleListeners(): Promise<void> {
    this._observerApp.attach('user:loggedin', this._firebase.updateAuthState.bind(this._firebase));
  }

  public getObserverAppInstance():IObserverApp {
    return this._observerApp;
  }

  public getContentManager():IContentManager {
    return this._contentManager;
  }

  public getFirebase():IFirebase {
    return this._firebase;
  }

  public getDataManager(): IDataManager {
    return this._dataManager;
  }

  public getSessionManager(): ISessionManager {
    return this._sessionManager;
  }

  public getAnalytics(): IAnalytics {
    return this._analytics;
  }

  public getTTS(): ITts {
    return this._tts;
  }
}
